// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__tc6Hu","loaderOuter":"PageOverlayLoader_loaderOuter__3CCaZ"};